import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BoatList from './pages/BoatList';
import BoatForm from './pages/BoatForm';
import PostList from './pages/PostList';
import PostDetail from './pages/PostDetail';
import ReportList from './pages/ReportList';
import ReportDetail from './pages/ReportDetail';
import FreshwaterSpotList from './pages/FreshwaterSpotList';
import ConditionList from './pages/ConditionList';
import ConditionBoardList from './pages/ConditionBoardList';
import UserList from './pages/UserList';
import UserDetail from './pages/UserDetail';
import HashtagList from './pages/HashtagList';
import CaptainList from './pages/CaptainList';
import CaptainNew from './pages/CaptainNew';
import CaptainApplications from './pages/CaptainApplications';
import AnnouncementList from './pages/AnnouncementList';
import AnnouncementForm from './pages/AnnouncementForm';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="boats" element={<BoatList />} />
              <Route path="boats/create" element={<BoatForm />} />
              <Route path="boats/edit/:id" element={<BoatForm />} />
              <Route path="posts" element={<PostList />} />
              <Route path="posts/:id" element={<PostDetail />} />
              <Route path="reports" element={<ReportList />} />
              <Route path="reports/:id" element={<ReportDetail />} />
              <Route path="freshwater-spots" element={<FreshwaterSpotList />} />
              <Route path="conditions" element={<ConditionList />} />
              <Route path="condition-boards" element={<ConditionBoardList />} />
              <Route path="users" element={<UserList />} />
              <Route path="users/:id" element={<UserDetail />} />
              <Route path="hashtags" element={<HashtagList />} />
              <Route path="captains" element={<CaptainList />} />
              <Route path="captains/new" element={<CaptainNew />} />
              <Route path="captain-applications" element={<CaptainApplications />} />
              <Route path="announcements" element={<AnnouncementList />} />
              <Route path="announcements/new" element={<AnnouncementForm />} />
              <Route path="announcements/edit/:id" element={<AnnouncementForm />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
